require('es6-promise').polyfill();
require('isomorphic-fetch');

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '192.168.179.28' ||
  window.location.hostname === '172.17.0.1' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

var host = ''
if (isLocalhost) {
  host = 'http://172.17.0.1:8000'
  //host = 'http://192.168.179.28:8000'
} else {
  host = 'https://www.menue-concept.de'
}
const realtiveUrl = '/api/v2/'
const baseUrl = host + realtiveUrl

const baseUrlCategories = baseUrl + 'categories/'
const baseUrlPages = baseUrl + 'pages/'


export const loadCategories = () => {
  return fetch(baseUrlCategories, {
    credentials: 'same-origin'
  }).then(result => {
      return result.json()
    }).then(json => {
      return json.items
    });
}


// export const loadArticles = function(categoryId, isVegetarian, isVegan, isWholeFood, isLightWholeFood, isCare, isGlutenFree, isLactoseFree, allergeneSearchText, searchText) {
  // let urlPages = baseUrlPages + '?fields=*&limit=6&category=' + categoryId
export const loadArticles = function(isVegetarian, isVegan, isWholeFood, isLightWholeFood, isCare, isGlutenFree, isLactoseFree, allergeneSearchText, searchText, categoryId, limit) {
  var urlPages = baseUrlPages + '?fields=*&limit=' + limit

  if (categoryId !== '') {
    urlPages = urlPages + '&category=' + categoryId
  }

  if (isVegetarian) {
    urlPages = urlPages + '&is_vegetarian=' + isVegetarian
  }

  if (isVegan) {
    urlPages = urlPages + '&is_vegan=' + isVegan
  }

  if (isWholeFood) {
    urlPages = urlPages + '&is_whole_food=' + isWholeFood
  }

  if (isLightWholeFood) {
    urlPages = urlPages + '&is_light_whole_food=' + isLightWholeFood
  }

  if (isCare) {
    urlPages = urlPages + '&is_care=' + isCare
  }

  if (isGlutenFree) {
    urlPages = urlPages + '&is_gluten_free=' + isGlutenFree
  }

  if (isLactoseFree) {
    urlPages = urlPages + '&is_lactose_free=' + isLactoseFree
  }

  if (allergeneSearchText) {
    urlPages = urlPages + '&allergens=' + allergeneSearchText
  }

  if (searchText) {
    urlPages = urlPages + '&search=' + searchText
  }

  return fetch(urlPages, {
    credentials: 'same-origin'
  }).then(result => {
      return result.json()
    });
}


/*
export const createServer = (server, username) => {
  server.user = baseUrlUser + username + '/'
  console.log(server)

  return fetch(baseUrlServer, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(server)
  }).then((res) => res.json())
}


export const loadBackups = () => {
  console.log(baseUrlBackup)
  return fetch(baseUrlBackup)
    .then(result => {
      return result.json()
    }).then(json => {
      return json.objects
    });
}
*/



// WEBPACK FOOTER //
// ./src/lib/DataHelpers.js